import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withId = /*#__PURE__*/_withScopeId("data-v-71d8d171");

_pushScopeId("data-v-71d8d171");

var _hoisted_1 = {
  class: "text-center loadingsign"
};

var _hoisted_2 = /*#__PURE__*/_createVNode("div", {
  class: "loading loading-lg"
}, null, -1);

var _hoisted_3 = /*#__PURE__*/_createVNode("span", {
  class: "text-bold"
}, "Podatki se osvežujejo", -1);

_popScopeId();

export var render = /*#__PURE__*/_withId(function (_ctx, _cache) {
  return _openBlock(), _createBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3]);
});